'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.default = void 0;
var set = function (e, t, n, o, c, a) {
        var i = [];
        if (i.push(''.concat(e, '=').concat(encodeURIComponent(t))), c) {
            var u = new Date();
            u.setTime(u.getTime() + c), i.push(';expires='.concat(u.toGMTString()));
        }
        i.push(n ? '; path='.concat(n) : ''), i.push(o ? '; domain='.concat(o) : ''), i.push(a ? '; secure' : ''), document.cookie = i.join('');
    }, setByEscape = function (e, t, n, o, c, a) {
        var i = [];
        if (i.push(''.concat(e, '=').concat(escape(t))), c) {
            var u = new Date();
            u.setTime(u.getTime() + c), i.push(';expires='.concat(u.toGMTString()));
        }
        i.push(n ? '; path='.concat(n) : ''), i.push(o ? '; domain='.concat(o) : ''), i.push(a ? '; secure' : ''), document.cookie = i.join('');
    }, getAll = function () {
        return '' !== document.cookie ? document.cookie.split(';').map(function (e) {
            var t = e.split('='), n = t.slice(1).join('=');
            try {
                n = decodeURIComponent(n);
            } catch (e) {
                n = unescape(n);
            }
            return {
                name: t[0].trim(),
                value: n
            };
        }) : [];
    }, get = function (e) {
        var t = getAll(), n = !0, o = !1, c = void 0;
        try {
            for (var a, i = t[Symbol.iterator](); !(n = (a = i.next()).done); n = !0) {
                var u = a.value;
                if (u.name === e)
                    return u.value;
            }
        } catch (e) {
            o = !0, c = e;
        } finally {
            try {
                n || null == i.return || i.return();
            } finally {
                if (o)
                    throw c;
            }
        }
        return '';
    }, del = function (e, t, n) {
        var o = [], c = new Date();
        c.setTime(c.getTime() - 1000), o.push(''.concat(e, '=')), o.push(t ? '; path='.concat(t) : ''), o.push(n ? '; domain='.concat(n) : ''), o.push(';expires='.concat(c.toGMTString())), document.cookie = o.join('');
    }, _default = {
        get: get,
        set: set,
        setByEscape: setByEscape,
        del: del
    };
exports.default = _default;